<div class="content">
    <app-logo class="logo" />
    <div></div>
    <div class="actions">
        <a routerLink="/profile" data-test="shell-header-profile-link">
            <app-avatar [image]="profile()?.avatarId ?? null | mediaSrc | async" [label]="initials()" size="md" />
        </a>
        <a pButton [text]="true" severity="secondary" routerLink="/auth/logout" data-test="shell-header-logout">
            <i class="pi pi-sign-out" pButtonIcon></i>
        </a>
    </div>
</div>
